import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  QueryList,
  ViewChildren
} from '@angular/core';
import { AuthenticationService, PerfilService } from 'src/app/services';
import { IPerfil } from 'src/app/interfaces';
import { Subscription } from 'rxjs';
import { MatAccordion } from '@angular/material/expansion';
import { IToken } from 'src/app/interfaces/token/IToken';

@Component({
  selector: 'app-sidebar-permissoes',
  templateUrl: './sidebar-permissoes.component.html',
  styleUrls: ['./sidebar-permissoes.component.scss']
})
export class SidebarPermissoesComponent implements OnChanges {
  @ViewChildren(MatAccordion) matAccordions: QueryList<MatAccordion>;
  @Output() fecharSidebar = new EventEmitter();
  @Output() permissoesAlteradas = new EventEmitter();
  @Input() perfilSelecionado: IPerfil;
  subscriptions$ = new Subscription();
  permissoesPerfil: IPerfil;
  salvarDesabilitado: boolean = true;
  token: IToken = this.authenticationService.obterToken();

  constructor(
    private perfilService: PerfilService,
    private authenticationService: AuthenticationService
  ) {}

  ngOnChanges() {
    this.permissoesPerfil = {
      ...this.perfilSelecionado
    };
  }

  salvarPermissoes() {
    this.subscriptions$.add(
      this.perfilService
        .putPerfil({
          ...this.permissoesPerfil,
          idUsuario: this.token.id,
          perfilId: this.perfilSelecionado.id
        })
        .subscribe({
          complete: () => {
            this.permissoesAlteradas.emit();
            this.fecharSidebar.emit();
          }
        })
    );
  }

  habilitarSalvar() {
    const permissoesPerfilString = JSON.stringify(this.permissoesPerfil);
    const perfilSelecionadoString = JSON.stringify(this.perfilSelecionado);

    if (permissoesPerfilString != perfilSelecionadoString) {
      this.salvarDesabilitado = false;
    } else {
      this.salvarDesabilitado = true;
    }
  }

  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }

  recolherPaineis() {
    for (let matAccordion of this.matAccordions) {
      matAccordion.closeAll();
    }
    this.salvarDesabilitado = true;
  }

  fechar() {
    this.fecharSidebar.emit();
  }
}
